import React from 'react';
import { AVERAGE_UNITS } from 'infrastructure/consts/average-units';
import { Flex, Typography } from 'antd';

import s from './styles.module.scss';

import type { IAverage } from 'infrastructure/interfaces';

const { Text } = Typography;

interface IAverageCell {
  average: IAverage;
}

const AverageCell: React.FC<IAverageCell> = ({ average }) => {
  const { name, value } = average;
  const isValueValid = Boolean(Number.parseInt(value));

  return (
    <Flex className={s['average-wrapper']}>
      <Flex vertical>
        <Text className={s['average-label']}>{name}</Text>
        <Flex align="baseline" gap={4}>
          <Text className={s['average-value']} data-empty={!isValueValid}>
            {isValueValid ? value : '-/-'}
          </Text>
          <Text className={s['average-unit']}>{AVERAGE_UNITS[name]}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AverageCell;
